import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'

let routeInfo = [
  {
    path: 'custCntr/noticeList',
    name: 'NoticeList',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/NoticeList.vue') }
    ),
    meta: {
      authorized: false,
      title: '공지사항'
    }
  },
  {
    path: 'custCntr/noticeDetail',
    name: 'NoticeDetail',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/NoticeDetail.vue')}
    ),
    meta: {
      authorized: false
    }
  },
  {
    path: 'custCntr/faqList',
    name: 'FaqList',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/FaqList.vue') }
    ),
    meta: {
      authorized: false,
      title: 'FAQ'
    }
  },
  {
    path: 'custCntr/inquiry',
    name: 'Inquiry',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/Inquiry.vue') }
    ),
    meta: {
      authorized: true,
      title: '1:1문의'
    }
  },
  {
    path: 'custCntr/mapMain',
    name: 'MapMain',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/MapMain.vue') }
    ),
    meta: {
      authorized: false,
      title: '찾아오시는 길'
    }
  },
  {
    path: 'custCntr/asscnAttltDisc',
    name: 'AsscnAttltDisc',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/AsscnAttltDisc.vue') }
    ),
    meta: {
      authorized: false,
      title: '단체수강할인'
    }
  },
  {
    path: 'custCntr/applLectr',
    name: 'ApplLectr',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/ApplLectr.vue') }
    ),
    meta: {
      authorized: false,
      title: '강사지원'
    }
  },
  {
    path: 'custCntr/remtSvc',
    name: 'RemtSvc',
    components: Object.assign({}, defaultLayoutComponent,
      { content: () => import(/* webpackChunkName: "page_custCntr" */ '~pages/nrw/custCntr/RemtSvc.vue') }
    ),
    meta: {
      authorized: false,
      title: '원격지원서비스'
    }
  }
]
export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/custCntrRouter.js